<template>
    <div :class="[addon||addonSlot||prepend||prependSlot ? 'input-group' : '']">
      <div class="input-group-prepend" v-if="prepend || prependSlot">
        <span class="input-group-addon">
          <span v-if="prepend" v-html="prepend" />
          <slot name="prepend"></slot>
        </span>
      </div>
      <select 
        class="form-control"
        v-bind:value="value"
        v-on:input="inputUpdated"
        v-bind:placeholder="placeholder"
        v-bind:class="{'is-invalid': hasError()}"
        v-if="!loadingSpinner && !loadingError"
        :readonly="readonly"
        :disabled="readonly">
        <template v-for="(item, index) in optionsLookup">
          <option v-if="item.children == undefined" :key="`${index}-${item.value}`" :value="item.value !== undefined ? item.value : item.name" v-html="item.name" :selected="(item.value !== undefined ? item.value : item.name) == value">
          </option>
          <optgroup v-if="item.children != undefined" :key="index" :label="item.name">
            <option v-for="childItem in item.children" :key="childItem.value" :value="childItem.value !== undefined ? childItem.value : childItem.name" v-html="childItem.name" :selected="(childItem.value !== undefined ? childItem.value : childItem.name) == value">
            </option>
          </optgroup>
        </template>
      </select>
      <div v-if="addon || addonSlot" class="input-group-append">
        <span class="input-group-addon" v-if="addon" v-html="addon" />
        <slot name="addon"></slot>
      </div>
      <Spinner v-if="loadingSpinner" />
      <div class="form-invalid-feedback" v-if="hasError()">
        {{getError()}}
      </div>
      <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
      <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
    </div>
</template>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormSelect",
  mixins: [formField],
  props: {
    value: [String, Number],
    options: Array,
    optionsPromise: Promise,
    placeholder: String,
    prepend: String,
    prependSlot: Boolean,
    addon: String,
    addonSlot: Boolean,
    field: String,
    readonly: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    note: String
  },
  watch: {
    value: function() {
      // Reset error when updating
      // Not 100% fix to clearing errors (eg, some errors may be logic based) but helpful
      this.resetFieldError(this.$props.field)
    },
    options: function (newVal, oldVal) {
      this.$data.optionsLookup = newVal
    },
    loading: function (newVal, oldVal) {
      this.$data.loadingSpinner = newVal
    }
  },
  mounted() {
    if(this.$props.optionsPromise != null) {
      this.$data.loadingError = null
      this.$data.loadingSpinner = true

      this.$props.optionsPromise.then(result => {
        this.$data.optionsLookup = result

        // If no value set in looup, check for default setting & set that as the default
        if(!this.$data.optionsLookup.some(lookup => lookup.value == this.value)) {
          var defaultOption = this.$data.optionsLookup.find(lookup => lookup.isDefault)
          if(defaultOption)
            this.$emit('input', defaultOption.value)
        }
      })
      .catch(err => {
        this.$data.loadingError = 'Error accessing data'
        console.error(err)
      })
      .finally(() => {
        this.$data.loadingSpinner = false
      })
    }
  },
  data() {
    return {
      loadingSpinner: this.$props.loading,
      optionsLookup: this.$props.options,
      loadingError: null
    } 
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    inputUpdated(evt) {
      this.$emit('input', evt.target.value)
    },
  }
};
</script>